import AdminGuard from '@/auth/guard/admin-guard';
import { RoleListPage, RoleEditPage, RoleCreatePage } from './imports';

export const roleRoutes = [
  {
    path: 'roles',
    children: [
      {
        element: (
          <AdminGuard hasContent>
            <RoleListPage />
          </AdminGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <AdminGuard hasContent>
            <RoleListPage />
          </AdminGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <AdminGuard hasContent>
            <RoleEditPage />
          </AdminGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <AdminGuard hasContent>
            <RoleCreatePage />
          </AdminGuard>
        ),
      },
    ],
  },
];
